import { render, staticRenderFns } from "./problemIndex.vue?vue&type=template&id=0434b11d"
import script from "./problemIndex.vue?vue&type=script&lang=js"
export * from "./problemIndex.vue?vue&type=script&lang=js"
import style0 from "./problemDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports